import apiClient from '../utils/apiClient';

const base = (facilityId) => `/api/facilities/${facilityId}/invoices`;

const invoicesService = {
  // Default to the last 90 days of invoices, newest due date first. Pass
  // sinceDays=null to fetch everything (e.g. an explicit date-range view).
  getAll: (facilityId, sinceDays = 90) =>
    apiClient.get(`${base(facilityId)}/`, {
      params: sinceDays ? { since_days: sinceDays } : undefined,
    }),
  // Open (unpaid, non-void) invoices for one customer, oldest due first.
  // Powers the Record-Payment invoice-matching checklist. Optionally narrow
  // to a single rental.
  getOpen: (facilityId, customerId, rentalId) =>
    apiClient.get(`${base(facilityId)}/open`, {
      params: { customer_id: customerId, ...(rentalId ? { rental_id: rentalId } : {}) },
    }),
  getById: (facilityId, id) => apiClient.get(`${base(facilityId)}/${id}`),
  create: (facilityId, data) => apiClient.post(`${base(facilityId)}/`, data),
  update: (facilityId, id, data) => apiClient.patch(`${base(facilityId)}/${id}`, data),
  send: (facilityId, id) => apiClient.post(`${base(facilityId)}/${id}/send`),
  void: (facilityId, id) => apiClient.post(`${base(facilityId)}/${id}/void`),
  payments: (facilityId, id) => apiClient.get(`${base(facilityId)}/${id}/payments`),
};

export default invoicesService;
